export default {"src":"/_next/static/media/46-icon.b8b0a530.svg","height":46,"width":28,"blurWidth":0,"blurHeight":0};